import Collapse from './Collapse';

export type { CollapseProps } from './Collapse';
export type { CollapsePanelProps } from './CollapsePanel';

export default Collapse;
